import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AttorneyDashboardRaw = React.lazy(() => import(/* webpackChunkName: "AttorneyDashboard" */ './AttorneyDashboard'));
export const AttorneyDashboard = () => (React.createElement(React.Suspense, { fallback: React.createElement(Spinner, null) },
    React.createElement(AttorneyDashboardRaw, null)));
